import React from 'react'
import { Button, useRefresh, useNotify, useUnselectAll, } from 'react-admin'
import IconBlock from '@material-ui/icons/Block'
import { assignCategory } from '../../../Model/Shop'


const handleAssignClick = (shopid, selectedIds, resource, refresh, notify, unselectAll) => {
    const data = {
        "shop_id": shopid,
        "sid[]": selectedIds,
    }
    assignCategory(data,shopid, (res) => {
        refresh()
        unselectAll(resource)
        notify(res.message)
    }, (res) => {
        notify(res.message, 'warning')
    })

}

const AssignCategoryButton = ({ shopid, selectedIds, resource }) => {
    const refresh = useRefresh()
    const notify = useNotify()
    const unselectAll = useUnselectAll()
    return (
        <Button label="Assign Category" icon={<IconBlock />} onClick={() => {
            handleAssignClick(shopid, selectedIds, resource, refresh, notify, unselectAll)
        }} />
    );
}

export default AssignCategoryButton